import { Stack } from "@mui/material";
import type { FC } from "react";
import type {
	ClientActivityAgentItemResponseDTO,
	ClientActivityParticipantItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DataNote } from "web_myplann/Shared/Components/DataNote";

type Props = {
	participants: ClientActivityParticipantItemResponseDTO[];
	agents: ClientActivityAgentItemResponseDTO[];
};

export const ActivityParticipants: FC<Props> = ({ participants, agents }) => {
	const { t } = useResource();

	const emptyRole = t(Resources.Activity.Detail.OtherClient);

	const clientParticipants = participants.filter((p) => p.role === "Client");
	const nonClientParticipants = participants.filter((p) => p.role !== "Client");

	const regularAgents = agents.filter((a) => !a.isAssistant);
	const assistantAgents = agents.filter((a) => a.isAssistant);

	return (
		<Stack>
			{clientParticipants.length > 0 && (
				<DataNote
					key="client-participants"
					label={t(Resources.Activity.Detail.Participants.client)}
					text={clientParticipants.map((p) => p.name ?? "-").join(", ")}
				/>
			)}

			{regularAgents.length > 0 && (
				<DataNote
					key="regular-agents"
					label={t(Resources.Activity.Detail.Agents.advisor)}
					text={regularAgents.map((a) => a.name ?? "-").join(", ")}
				/>
			)}

			{assistantAgents.length > 0 && (
				<DataNote
					key="assistant-agents"
					label={t(Resources.Activity.Detail.Agents.assistant)}
					text={assistantAgents.map((a) => a.name ?? "-").join(", ")}
				/>
			)}

			{nonClientParticipants.map((participant) => {
				return (
					<DataNote
						key={`client-participants-${participant.id}`}
						label={participant.role ?? emptyRole}
						text={participant.name ?? ""}
					/>
				);
			})}
		</Stack>
	);
};
